import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { client } from '@authy/lib-client/trpc'

import { rootRoute } from '@/tenant/settings/root'
import { appState } from '@/appState'

export const accountAppRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/account-app',
    component: lazyRouteComponent(() => import('./AccountApp'), 'AccountApp'),
    loader: async ({ abortController, parentMatchPromise }) => {
        await parentMatchPromise

        const accountSettings = await client.tenants.getTenantAccountManagementSettings.query(
            { tenantId: appState.tenant!._id.toString() },
            { signal: abortController.signal }
        )

        return { accountSettings }
    },
})
